import { Controller } from "@hotwired/stimulus"

// Shows/hides the QR, article-1 and article-2 field groups on the
// CanvasTemplate form based on their visibility checkboxes.
export default class extends Controller {
  static targets = [
    "qrCheckbox", "qrFields",
    "article1Checkbox", "article1Fields",
    "article2Checkbox", "article2Fields"
  ]

  connect() {
    this.syncQr()
    this.syncArticle1()
    this.syncArticle2()
  }

  syncQr() {
    this.toggle(this.qrCheckboxTarget, this.qrFieldsTarget)
  }

  syncArticle1() {
    this.toggle(this.article1CheckboxTarget, this.article1FieldsTarget)
  }

  syncArticle2() {
    this.toggle(this.article2CheckboxTarget, this.article2FieldsTarget)
  }

  toggle(checkbox, container) {
    container.hidden = !checkbox.checked
  }
}
